// Text Input Component
// Creates a text input field with auto-select on focus and optional Enter key submission

/**
 * Create a text input element with auto-select on focus
 * @param {Object} options - Configuration options
 * @param {string} options.id - Input element ID
 * @param {string} options.name - Input element name
 * @param {string} options.value - Initial value
 * @param {string} options.placeholder - Placeholder text
 * @param {string} options.type - Input type (default: 'text')
 * @param {boolean} options.required - Whether the field is required
 * @param {string} options.className - Additional CSS classes
 * @param {Function} options.onSubmit - Optional callback when Enter key is pressed
 * @param {Function} options.onInput - Optional callback when input value changes
 * @returns {HTMLInputElement} The configured input element
 */
export function createTextField({
    id = '',
    name = '',
    value = '',
    placeholder = '',
    type = 'text',
    required = false,
    className = '',
    onSubmit = null,
    onInput = null
} = {}) {
    const input = document.createElement('input');
    input.type = type;
    if (id) input.id = id;
    if (name) input.name = name;
    if (className) input.className = className;
    if (required) input.required = true;
    input.placeholder = placeholder;
    input.value = value;

    // Select all text on focus
    input.addEventListener('focus', (e) => {
        e.target.select();
    });

    // Submit on Enter key if callback provided
    if (onSubmit) {
        input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                onSubmit(input.value);
            }
        });
    }

    // Handle input changes if callback provided
    if (onInput) {
        input.addEventListener('input', (e) => {
            onInput(e.target.value);
        });
    }

    return input;
}
